<template>
  <div class="container">
    <app-header title="上传报价单"/>
    <div>
      <van-field label="分类" readonly clickable placeholder="请选择分类" :value="station" @click="showPicker = true" />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" @change="onChange" />
      </van-popup>
    </div>
    <div class="main">
      <div class="excel" v-for="(item,index) in fileList" :key="index">
        <img src="@/assets/excel.png" alt="文档" width="33" height="33" v-if="item.name.endsWith('xls') || item.name.endsWith('xlsx')">
        <img src="@/assets/word.png" alt="文档" width="33" height="33" v-if="item.name.endsWith('doc') || item.name.endsWith('docx')">
        <div class="name">{{item.name}}</div>
      </div>
      <div class="image">
        <van-uploader  :after-read="afterRead" :accept="accept"  upload-icon="plus" />
      </div>
    </div>
    <div class="submit" @click="onSubmit">提交</div>
    <div class="my-container">
      <van-popup v-model="show" get-container="#my-container" :style="{ height: '400px',width: '90%',borderRadius: '6px' }">
        <div class="content">
          <div><img src="@/assets/close.png" alt="关闭" width="16" height="16" @click="show = false"></div>
          <div class="title">请填写联系人信息，更加方便提供服务！</div>
          <div class="form-item">
            <label for="username">联系人</label>
            <!--<input type="text" id="name">-->
            <page-input v-model="row.username" class="input" id="username"/>
          </div>
          <div class="form-item">
            <label for="phone">联系电话</label>
            <!--<input type="text" id="tel">-->
            <page-input v-model="row.phone" class="input" id="phone"/>
          </div>
          <div class="form-item">
            <label for="company">公司名称</label>
            <!--<input type="text" id="compony">-->
            <page-input v-model="row.company" class="input" id="company"/>
          </div>
          <div class="submit" @click="onSubmit">完成</div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
    import { saveShopPrice } from '@/api/shopPrice'
    import { treeMenu } from '@/api/category'
    import {image,uploadFile} from '@/api/file'
    export default {
      name: "file",
      data(){
          return{
            station: "",
            showPicker: false,
            columns: [],
            menuTree: [],
            provinceList: [],
            cityList: [],
            countyList: [],

            show: false,
            accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, ' +
                    'application/vnd.ms-excel,' +
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
                    'application/msword',
            // 图片列表
            fileList: [],
            row: {
              type: this.$route.query.type,
              file: '',
              uid: '',
              username: '',
              phone: '',
              company: '',
              fileType: 0,
              fromType : 0,
              isTaxInclusive : this.$route.query.inclusive
            }
          }
      },
      created(){
        this.treeMenu()
      },
      methods: {
        treeMenu(){
          treeMenu({type: this.row.type}).then(res=>{
            if (res.success){
              this.menuTree = res.data.menuTree
              this.cityList = this.menuTree[0].children
              let citys = res.data.menuTree
              this.columns = [
                {
                  values: citys,
                  className: "column1"
                },
                {
                  values: citys[0].children,
                  className: "column2"
                },
                {
                  values: citys[0].children[0].children,
                  className: "column3"
                }
              ]
            }

          })
        },
        onConfirm(value) {
          console.log(value)
          const compact = arr => arr.filter(Boolean); // 三级联动 去除没值的，比如只有两级
          const result = compact(value);
          let str = "";  // 呈现页面显示  /xxx/xxx/xxx
          result.forEach(item => {
            if (!str){
              str = item.text;
            } else {
              str += "/" + item.text;
            }
          });
          this.station = str;
          this.showPicker = false;

          const end = result[result.length - 1]; // 一般都是取最后一个id给后台的
          const id = end.id;
          const name = end.name;
          this.row.typeTwo = id
          this.row.typeTwoName = name
        },
        onChange(picker, values, index) {

          let ColumnIndex = picker.getColumnIndex(index);
          console.log("第" + index + "列", "第" + ColumnIndex + "个");

          if (index == 0) {
            this.cityList = this.menuTree[ColumnIndex].children
            if (this.cityList.length > 0){
              picker.setColumnValues(1, this.cityList);
              picker.setColumnValues(2, this.cityList[0].children || []);
            } else{
              picker.setColumnValues(1, []);
              picker.setColumnValues(2, []);
            }
          }

          if (index == 1){
            this.countyList = this.cityList[ColumnIndex].children
            picker.setColumnValues(index + 1, this.countyList || []);
          }
        },
        onSubmit() {
          if (!this.row.typeTwo){
            this.$toast.fail('请选择分类')
            return;
          }
          if (this.fileList.length <= 0){
            this.$toast.fail('请上传文件')
            return;
          }
          //供应商信息
          var store = JSON.parse(localStorage.getItem('store'))
          this.row.name = store.companyName
          this.row.phone = store.tel
          //供应商账号信息
          var user = localStorage.getItem('storeInfo')
          if (!user){
            this.$router.push({
              path: '/business/supplierLogin'
            })
            return
          }
          user = JSON.parse(user)
          this.row.uid = user.id
          this.row.username = user.username

          let values = JSON.stringify(this.fileList)
          this.row.files = values
          saveShopPrice(this.row).then((res) => {
            if (res.success) {
              this.$toast.success('成功')
              setTimeout(() => {
                this.$router.go(-1)
              },2500)
            }
          })
        },
        afterRead(file) {
          this.upload(file);
        },
        upload(file){
          let formData = new FormData()
          formData.append('file', file.file)
          uploadFile(formData).then(res => {
            if (res.success) {
              this.fileList.push({
                name: file.file.name,
                url: res.data
              });
            }else{
              this.$toast.fail(res.msg)
            }
          }).catch(err=>{

          })
        },
        delImg (index) {
          // 删除指定下标的图片对象
          if (isNaN(index) || index >= this.fileList.length) {
            return false
          }
          let tmp = []
          for (let i = 0, len = this.fileList.length; i < len; i++) {
            if (this.fileList[i] !== this.fileList[index]) {
              tmp.push(this.fileList[i])
            }
          }
          this.fileList = tmp
        },
      }
    }
</script>

<style lang="less" scoped>
  .container{
    width: 100vw;
    height: auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow-y: scroll;
    padding-bottom: 60px;
    font-size: 14px;
    .main{
      padding: 12px;
      .tip{
        font-size:10px;
        font-weight:400;
        line-height:14px;
        color:rgba(254,0,59,1);
      }
      .excel{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 0 8px 0;
        .name{
          margin-left: 15px;
        }
      }
      .image{
        padding: 10px 16px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        box-sizing: border-box;
        width: 100%;
        padding: 10px 0px;
        overflow: hidden;
        .item{
          display: block;
          width: 80px;
          height: 80px;
          border-radius: 8px;
          position: relative;
          margin: 0 8px 8px 0;
          cursor: pointer;
          .imgPreview{
            width: 80px;
            height: 80px;
          }
          .delte{
            position: absolute;
            top: -8px;
            right: -8px;
            color: #969799;
            font-size: 18px;
            background-color: #fff;
            border-radius: 100%;
          }
        }
      }
    }
    .submit{
      position: fixed;

      right: 12px;
      bottom: 12px;
      left: 12px;
      height: 50px;
      line-height: 50px;
      background: #F1124C;
      text-align: center;
      color: #ffffff;
      border-radius: 5px;
    }
    .my-container{
      .content{
        padding: 10px;
        .title{
          height:22px;
          font-size:16px;
          font-weight:bold;
          color:rgba(51,51,51,1);
          text-align: center;
        }
        .form-item{
          display: flex;
          flex-direction: row;
          padding: 0 15px;
          margin-top: 25px;
          label{
            width: 75px;
            height: 40px;
            line-height: 40px;
            display: inline-block;
          }
          .input{
            //height:40px;
            border:1px solid rgba(243,243,243,1);
            border-radius:4px;
            padding: 10px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/business/price/file.vue